var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnInit } from '@angular/core';
import { Pagination, Table, TableData, TableDataTypes } from 'src/app/shared/types';
import { CaptainCallLogsService } from '../../captain-call-logs.service';
var CaptainCallLogsComponent = /** @class */ (function () {
    function CaptainCallLogsComponent(captainCallLogsService) {
        this.captainCallLogsService = captainCallLogsService;
        this.toggleHeaders = new EventEmitter();
        this.dataLoaded = false;
    }
    CaptainCallLogsComponent.prototype.ngOnInit = function () {
        this.declareTable();
    };
    CaptainCallLogsComponent.prototype.declareTable = function () {
        var _this = this;
        this.captainCallLogs = new Table({
            toggleableHeaders: this.captainDetailsToggleableHeaders,
            headers: {
                timeOfCall: 'Time of call',
                orderID: 'Order Id',
                reasonForCall: 'Reason for call',
                remarks: 'Remarks',
            },
            pagination: new Pagination(0, 10, 30, [10, 15, 20], 0, true),
            selectedHeader: 8,
            defaultError: 'No Call Logs found',
            onRefresh: function () {
                _this.captainCallLogs = null;
                _this.ngOnInit();
            },
            data: []
        });
        this.getCallLogs();
    };
    CaptainCallLogsComponent.prototype.getCallLogs = function (pageNumber, perPage) {
        if (pageNumber === void 0) { pageNumber = 1; }
        if (perPage === void 0) { perPage = 10; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.dataLoaded = false;
                this.captainCallLogsService.getCaptainCallLogs(this.captainId, pageNumber, perPage)
                    .then(function (response) {
                    var logs = response.result.callLogs.logs;
                    var totalLogs = response.result.callLogs.count;
                    _this.captainCallLogs.data = logs.map(function (callLog) {
                        return {
                            timeOfCall: _this.createTableData(callLog.startTime),
                            orderID: _this.createTableData(callLog.orderId ? callLog.orderId : 'NA'),
                            reasonForCall: _this.createTableData(callLog.subDisposition ? callLog.subDisposition : 'NA'),
                            remarks: _this.createTableData(callLog.remarks ? callLog.remarks : 'NA'),
                        };
                    });
                    _this.captainCallLogs.pagination = new Pagination((pageNumber - 1), perPage, totalLogs, [10, 15, 20], 0, true),
                        _this.dataLoaded = true;
                }).catch(function (err) {
                    console.log(err);
                    _this.captainCallLogs.data = [];
                    _this.captainCallLogs.defaultError = err.error.message || 'Error while fetching CallLogs,Please try Later.';
                    _this.dataLoaded = true;
                });
                return [2 /*return*/];
            });
        });
    };
    CaptainCallLogsComponent.prototype.dateString = function (epoch) {
        return new Date(epoch * 1000).toLocaleString();
    };
    CaptainCallLogsComponent.prototype.createTableData = function (value, className, type, flag, hoverData) {
        if (flag === void 0) { flag = false; }
        if (hoverData === void 0) { hoverData = null; }
        return new TableData({
            data: value,
            type: type ? type : TableDataTypes.DATA,
            flag: flag,
            hoverData: hoverData,
            className: className ? className + ' cursor-pointer' : 'cursor-pointer whiteSpacePre',
        });
    };
    CaptainCallLogsComponent.prototype.changeInHeader = function (header) {
        this.toggleHeaders.emit(header);
    };
    CaptainCallLogsComponent.prototype.onPaginationChange = function (event) {
        this.getCallLogs((event.pageNo + 1), event.perPage);
    };
    return CaptainCallLogsComponent;
}());
export { CaptainCallLogsComponent };
